import {MainLoader} from '@app/components/index';
import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {downloadReportPdf} from './redux/api';

const StyledIframe = styled.iframe`
  width: 100%;
  height: 450px;
`;

const DownloadAndViewReport = ({reportId}) => {
  const [downloadedPdf, setDownloadedPdf] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    downloadReportPdf({reportId})
      .then((res) => {
        if (!res.error) {
          setDownloadedPdf(res.data);
        } else {
          setDownloadedPdf(null);
        }
        return res;
      })
      .catch((ex) => {
        return ex;
      })
      .finally(() => {
        setLoading(false);
      });
  }, [reportId]);
  return (
    <>
      {loading && (
        <MainLoader
          minHeight="100vh"
          spinnerColor="#479541"
          background="rgba(0,0,0,0.2)"
        />
      )}
      {downloadedPdf ? (
        <StyledIframe
          src={`data:application/pdf;base64,${downloadedPdf}`}
          frameBorder="0"
        />
      ) : (
        <div style={{height: '450px'}}>Loading...</div>
      )}
    </>
  );
};

export default DownloadAndViewReport;
